import React from 'react';
import styles from './CreateCycleForm.module.scss';
import FormTextField from '../../../../../Common/FormTextField/FormTextField';
import FormCheckbox from '../../../../../Common/FormCheckbox/FormCheckbox';

export default function CreateCycleForm() {
  return (
    <>
      <div className={styles.fields}>
        <FormTextField
          name="label"
          label="Label"
          defaultHelperText="Label for this cycle."
          rules={{
            required: { value: true, message: 'Label is required.' },
          }}
        />
        <FormCheckbox
          name="isCurrent"
          label="Current cycle"
          helper="Please check this box if you would like this new cycle to be set as current cycle for the platform."
        />
      </div>
    </>
  );
}
